import {
    MAPIBANPROVIDER_SUCCESS,
    MAPIBANPROVIDER_FAILED,
    RESET_MAPIBANPROVIDER,
    LOADING_MAPIBANPROVIDER,
    NETWORK_ERROR_MAPIBANPROVIDER
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminMapIbanProvider = () => {
    return { type: RESET_MAPIBANPROVIDER };
};

const adminMapIBANProviderLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_MAPIBANPROVIDER });
    await adminServices
        .post("mapIbanProvider", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminMapIBANProvidersuccess(res.data));
                    break;
                default:
                    dispatch(adminMapIBANProviderFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_MAPIBANPROVIDER,
                payload: err
            });
        });
};


function adminMapIBANProvidersuccess(data) {
    return {
        type: MAPIBANPROVIDER_SUCCESS,
        payload: data
    };
}
function adminMapIBANProviderFailed(data) {
    return {
        type: MAPIBANPROVIDER_FAILED,
        payload: data
    };
}

export { adminMapIBANProviderLists, resetAdminMapIbanProvider }